<div class="container" #container [class.disabledInput]="isDisabled">
    <div
        class="input-wrapper"
        [class.dark]="dark"
        (click)="openSelect()"
        [class.dark]="dark"
        [class.selecting]="isShowSelect"
        [style.cursor]="isDisabled ? 'not-allowed' : 'pointer'">
        <p
            class="input-label"
            data-cy="channel-select-input-dropdown-label"
            [class.dark]="dark"
            [class.show]="isShowSelect || inputValue"
            [class.selecting]="isShowSelect">
            {{ label | translate }}
        </p>
        <input
            data-cy="channel-select-input-dropdown"
            [name]="name"
            [value]="inputValue | translate"
            [placeholder]="isShowSelect ? '' : (label | translate)"
            readonly
            [class.dark]="dark" />
        <div class="arrow-wrapper" [class.dark]="dark">
            <mat-icon class="arrow" [class.focus]="isShowSelect" svgIcon="dropdown-arrow" />
        </div>
    </div>
    <div
        *ngIf="isShowSelect && categoryList"
        class="select-list-container"
        [ngStyle]="{ maxHeight: height ? height + 'px' : 'auto' }">
        <div *ngFor="let category of categoryList" class="select-list">
            <div
                class="item"
                data-cy="channel-select-input-dropdown-option-category"
                [class.selected]="item === inputValue"
                (click)="selectValue($event, category)">
                {{ category.category | translate }}
            </div>
        </div>
    </div>

    <div
        *ngIf="isShowSelect && itemList"
        class="select-list-container"
        [class.dark]="dark"
        [ngStyle]="{ maxHeight: height ? height + 'px' : 'auto' }">
        <div *ngFor="let item of itemList" class="select-list" [class.dark]="dark">
            <div
                class="item"
                data-cy="channel-select-input-dropdown-option-item"
                [class.dark]="dark"
                [class.selected]="item === inputValue"
                (click)="selectValue($event, item)">
                {{ item | translate }}
            </div>
        </div>
    </div>
</div>
